import { FormItem } from 'components/use-form';
import { AgencyAbility } from 'model/agency';
import { APPTYPE } from 'pages/regist/const/constant';

export const abilityFormConfig: Array<FormItem> = [
  {
    name: 'service_industry',
    label: '主要服务行业',
    render: (data: AgencyAbility) => {
      return data.service_industry?.map((v) => v.industry_name).join(', ');
    },
  },
  {
    name: 'business_cooperation_cert',
    label: '产品商业化合作证明',
    type: 'file',
  },
  {
    name: 'industry_customer_size',
    label: '服务行业及客户数量',
  },
  {
    name: 'financing',
    label: '是否融资',
    render: (data: AgencyAbility) => {
      if (data.financing === null || data.financing === undefined) {
        return '-';
      }
      return data.financing ? '是' : '否';
    },
  },
  {
    name: 'financing_company',
    label: '融资公司名称',
    display: (data: AgencyAbility) => {
      return !!data.financing;
    },
  },
  {
    name: 'app_name',
    label: '应用名称',
  },
  {
    name: 'app_type',
    label: '应用类型',
    render: (data: AgencyAbility) => {
      return APPTYPE[data.app_type || ''] || '-';
    },
  },
  {
    name: 'app_introduction',
    label: '应用介绍',
    type: 'file',
  },
  {
    name: 'service_case',
    label: '服务案例/能力举证',
    type: 'file',
  },
  {
    name: 'fees',
    label: '收费标准',
    type: 'file',
  },
  {
    name: 'attached_files',
    label: '其他补充资料',
    type: 'file',
  },
];
